<template>
  <div class="nav">
    <el-button class="uni-button-1" @click="route_to('/')">首页</el-button>
    <el-button class="uni-button-1" @click="route_to('/help')">帮助</el-button>
    <el-dropdown @command="handleCommand">
      <span class="uni-button-1" style="height: 100%; border-radius: 4px">其它文档</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="rpc">RPC文档</el-dropdown-item>
        <el-dropdown-item command="ctl_doc">运动控制库文档</el-dropdown-item>
        <el-dropdown-item command="ctl_lib">运动控制库API</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  methods: {
    route_to(path) {
      if (this.$route.path != path) {
        this.$router.push(path)
      }
    },
    // 处理drop down
    handleCommand(command) {
      switch (command) {
        case "rpc":
          this.route_to("/doc/introduce")
          break
        case "ctl_doc":
          window.location.href = "http://ctl.rosc.org.cn/"
          break
        case "ctl_lib":
          window.location.href = "http://ctldoc.rosc.org.cn/"
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.nav {
  background: $background-1;
  height: $nav-bar-height;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid white;

  .uni-button-1 {
    width: 80px;
  }
}
</style>

<style lang="scss">
.nav {
  .el-dropdown {
    display: flex;
    align-items: center;
  }

  .el-button + .el-button {
    margin: 0px;
  }
}
</style>
